<template>
    <b-overlay :show="submitting" class="row d-flex flex-column flex-grow-1 align-items-center">
        <section class="col-xl-5 col-md-6 mt-4">
            <page-header> {{ $t('entrypage.hello') }}, {{ userName }} 👋</page-header>

            <p>{{ $t('entrypage.header') }}</p>

            <p>{{ $t('entrypage.description') }}</p>

            <a href="https://getbuybox.com/dodawanie-stron-i-profili-social-media/" target="_blank">{{ $t('entrypage.link') }}</a>

            <h5 class="mt-4 mb-3">{{ $t('enterYourWebsiteDetails') }}</h5>

            <b-form @submit.prevent>
                <FormValidator form-group :validator="$v.form.url" v-slot="slotProps" :label="$t('url')">
                    <b-form-input v-model="form.url" :placeholder="$t('https')" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator form-group :validator="$v.form.name" v-slot="slotProps" :label="$t('name')">
                    <b-form-input v-model="form.name" :placeholder="$t('entryNamePlaceholder')" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator form-group :validator="$v.form.categories" v-slot="slotProps" :label="$t('category')">
                    <Multiselect
                        :value="form.categories"
                        :multiple="true"
                        :clear-on-select="false"
                        :close-on-select="false"
                        :fetch-options-function="fetchCategories"
                        :parse-options-function="parseCategories"
                        :state="slotProps.state"
                        :disabled="submitting"
                        @change="items => (form.categories = items.map(v => v.value))"
                    />
                </FormValidator>
                <FormValidator form-group :validator="$v.form.type" v-slot="slotProps" :label="$t('type')">
                    <Multiselect
                        v-model="form.type"
                        :fetch-options-function="fetchSpaceTypes"
                        :parse-options-function="parseSpaceTypes"
                        :state="slotProps.state"
                        :disabled="submitting"
                    />
                </FormValidator>

                <div class="d-flex flex-column align-items-start gap-6 mt-4">
                    <b-button type="submit" variant="primary" :disabled="submitting" class="px-4" @click="handleSubmit">
                        {{ $t('save') }}
                    </b-button>

                    <b-button variant="link" :disabled="submitting" class="p-0" @click="skipEntryPage">
                        {{ $t('entrypage.skip') }}
                    </b-button>
                </div>
            </b-form>
        </section>
    </b-overlay>
</template>



<script>
    import { required, url, minLength } from 'vuelidate/lib/validators';
    import { uniqueUrl } from '@/utils/validators';
    import FormValidator from '@/components/common/FormValidator.vue';
    import categoryService from '@/services/categoryService';
    import spaceService from '@/services/spaceService';
    import Multiselect from '@/components/common/Multiselect.vue';

    const EXCLUDED_URLS = ['facebook.com', 'instagram.com', 'tiktok.com', 'youtube.com', 'google.pl', 'google.com', 'allegro.pl', 'vinted.pl'];

    export default {
        name: 'EntryPage',
        components: {
            FormValidator,
            Multiselect,
        },
        data() {
            return {
                form: {
                    name: '',
                    url: '',
                    categories: [],
                    type: null,
                },
                formInitData: {},
                submitting: false,
            };
        },
        validations() {
            return {
                form: {
                    name: { required },
                    url: {
                        required,
                        url,
                        unique: value => uniqueUrl(value, this.spacesUrlList),
                        tooGeneralUrl: value => uniqueUrl(value, EXCLUDED_URLS),
                    },
                    categories: { required, minLength: minLength(1) },
                    type: { required },
                },
            };
        },
        computed: {
            userRoleShort() {
                return this.$store.getters['auth/getRoleShortName'];
            },
            spaceCount() {
                return this.$store.getters['space/spaceCount'];
            },
            user() {
                return this.$store.getters['auth/getUser'];
            },
            userName() {
                return this.user?.firstName;
            },
            spacesUrlList() {
                return Object.values(this.$store.state.space.spaces).map(item => item.url);
            },
        },
        watch: {
            spaceCount: {
                handler() {
                    if (this.spaceCount > 0) {
                        this.$router.push({ name: 'Dashboard', params: { role: this.userRoleShort } });
                    }
                },
                immediate: true,
            },
        },
        methods: {
            resetForm() {
                Object.keys(this.form).forEach(key => {
                    if (key in this.formInitData) this.form[key] = this.formInitData[key];
                });
                this.$v.$reset();
            },
            handleSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.submitting = true;
                this.formRequest()
                    .then(this.requestSuccess)
                    .catch(error => this.$toastr.error(error.message))
                    .finally(() => (this.submitting = false));
            },
            formRequest() {
                const data = { ...this.form };
                if (typeof data.type === 'object') {
                    data.type = data.type.value;
                }
                return this.$store.dispatch('space/createSpace', data);
            },
            async requestSuccess() {
                try {
                    window.Gleap.startBot('67920bd6564866e4e7525004');
                } catch (error) {
                    console.error(error);
                }

                const msg = this.$t('pages.createSuccess', { name: this.form.name });
                this.$toastr.success(msg);
                this.resetForm();
                this.skipEntryPage();
            },
            fetchCategories() {
                return categoryService.getCategories();
            },
            parseCategories(data) {
                return data.map(({ id, name }) => ({ value: id, text: name }));
            },
            fetchSpaceTypes() {
                return spaceService.fetchSpaceTypes();
            },
            parseSpaceTypes(data) {
                return data?.items?.map(({ value, label }) => ({ value: String(value), text: label }));
            },
            skipEntryPage() {
                this.$sessionStorage.set('skipEntryPage', true);
                this.$router.push({ name: 'Dashboard', params: { role: this.userRoleShort } }).catch(() => {});
            },
        },
    };
</script>
